import { render, staticRenderFns } from "./use-svg.vue?vue&type=template&id=21c2b426"
import script from "./use-svg.vue?vue&type=script&lang=js"
export * from "./use-svg.vue?vue&type=script&lang=js"
import style0 from "./use-svg.vue?vue&type=style&index=0&id=21c2b426&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports